var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import infraService from "@/core/services/infraService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { UnidadeActions } from "@/store/enums/InfraEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let UnidadeModule = class UnidadeModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = UnidadeActions.POST_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.post("Unidade/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = UnidadeActions.PUT_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.put("Unidade/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = UnidadeActions.DELETE_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.delete("Unidade/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = UnidadeActions.DELETE_RANGE_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.delete("Unidade/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = UnidadeActions.FILTER_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.post("Unidade/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = UnidadeActions.GET_UNIDADE]() {
        return new Promise(resolve => {
            infraService.get("Unidade/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = UnidadeActions.GETWITHDISABLED_UNIDADE]() {
        return new Promise(resolve => {
            infraService.get("Unidade/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = UnidadeActions.GET_BY_ID_UNIDADE](data) {
        return new Promise(resolve => {
            infraService.get("Unidade/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UnidadeModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UnidadeModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UnidadeModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UnidadeModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UnidadeModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UnidadeModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UnidadeModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UnidadeModule.prototype, _h, null);
UnidadeModule = __decorate([
    Module
], UnidadeModule);
export default UnidadeModule;
//********** COMENTÁRIO GERADO EM: 31/05/2022 05:55:32 **********
//
//import infraService from "@/core/services/infraService";
//import JwtService from "@/core/services/JwtService";
//import {UnidadeActions, Mutations} from "@/store/enums/StoreEnums";
//import {Module, Action, VuexModule} from "vuex-module-decorators";
//
//
//@Module
//export default class UnidadeModule extends VuexModule {
//    errors = {};
//    isAuthenticated = !!JwtService.getToken();
//    
//
//    @Action
//    [UnidadeActions.POST_UNIDADE] (data) {
//        return new Promise(resolve => {
//			infraService.post("Unidade/Post", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//		});
//    }
//
//	@Action
//	[UnidadeActions.PUT_UNIDADE] (data) {
//        return new Promise(resolve => {
//            infraService.put("Unidade/Put", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[UnidadeActions.DELETE_UNIDADE](data) {
//        return new Promise(resolve => {
//            infraService.delete("Unidade/Delete", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[UnidadeActions.DELETE_RANGE_UNIDADE](data) {
//        return new Promise(resolve => {
//            infraService.delete("Unidade/DeleteRange", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[UnidadeActions.FILTER_UNIDADE](data) {
//        return new Promise(resolve => {
//            infraService.post("Unidade/Filter", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[UnidadeActions.GET_UNIDADE]() {
//        return new Promise(resolve => {
//            infraService.get("Unidade/Get")
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//    [UnidadeActions.GETWITHDISABLED_UNIDADE]() {
//        return new Promise(resolve => {
//            infraService.get("Unidade/GetWithDisabled")
//				  .then(({ data }) => {
//				resolve(data);
//			})
//                .catch (({ response }) => {
//				this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[UnidadeActions.GET_BY_ID_UNIDADE](data) {
//        return new Promise(resolve => {
//            infraService.get("Unidade/GetById", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//}
//********** FIM DO COMENTÁRIO **********
//# sourceMappingURL=UnidadeModule.js.map